module.exports = __webpack_public_path__ + "static/img/oddvega_img.4122a483.png";